import http, { url } from '../../http'

const API_URL = "hazard_identification"

class hazardIdentificationAPI {

  async save(hazardIdentification) {
    const response = await http(`${API_URL}/save`, 'POST', hazardIdentification)
    return response
  }
  
  async getAllIdentification() {
    const response = await http(`${API_URL}`)
    return response
  } 
 
  async getAllIdentificationCompany(id,  page, search) {
    const response = await http(`${API_URL}/company/${id}?page=${page}&search=${search}` , 'POST')
    return response
  } 
 
  async getIdentification(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async updateIdentification(id, identificacion) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', identificacion)
    return response
  }

  async deleteIdentification(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

 
  
}

export default new hazardIdentificationAPI()